import React from "react";

// La fonction ShowProbableInference est appelée par MakeAllInferences.
// Elle sert simplement à afficher en transparence la dernière inférence du tableau d'inférence, pour que même quand l'utilisateurice n'a rien fait encore, on ait une estimation/feedback sur ce que ça pourrait être (pour guider l'utilisateurice dans sa création).
// Cette fonction est à ne pas confondre avec InferenceForecaster, qui est appelée par RuleModal et ShowInformationsExercise, et qui fait un travail plus précis sur des infos plus limitées (i.e. les arguments rentrés par une utilisateurice en fonction de son activité sur la page d'exercices).

function ShowProbableInference(value, previousInference) {
  let ruleName = value.ruleModalContent.ruleName,
    expectedArguments = value.ruleModalContent.expectedArguments;
  if (value.otherInterpretation[0] === "active") {
    ruleName = value.ruleModalContent.otherInterpretation.ruleName;
    expectedArguments =
      value.ruleModalContent.otherInterpretation.expectedArguments;
  }
  let probableInference = value.probableInference,
    // checkSquareClassName = "-inactive",
    // newInference = {},
    classNames = "",
    hypothesisLevel = "",
    hypothesisLevelNumber = Number(previousInference.level),
    probableCommentary = "?, " + ruleName;
  let setAdequacyArrows = "",
    AIT = value.allInferencesThemselves,
    SN = value.storedNumbers;
  if (
    value.canInferenceBeStored &&
    value.booleansOptionsAboutInferences.boolInferenceScanner &&
    AIT.length > 0 &&
    expectedArguments
  ) {
    // Section de la création des adequacyArrows
    setAdequacyArrows = makeSetAdequacyArrows(
      value,
      ruleName,
      AIT,
      SN,
      expectedArguments
    );
  }
  console.log("4.0 ruleName", ruleName);
  if (ruleName === "rep") {
    console.log("4.1 bonjour");
    if (probableInference.active === false) {
      console.log("4.2 euh rebonjour");
    }
  } else if (probableInference.active === false) {
    console.log(
      "4.3) probableInference.active est",
      probableInference.active,
      "alors qu'il devrait pas être false !!!"
    );
    console.log("4.4 probableInference.itself", probableInference.itself);
    probableInference.itself = "prochaine inférence";
    probableCommentary = "?";
    if (ruleName) {
      probableCommentary = "?";
    }
  } else if (
    probableInference.activable === true // ruleName !== "rep"
  ) {
    if (ruleName !== "hyp") {
      // pour presque toutes les règles, sauf hyp, on va rajouter le nombre de l'inférence qui justifie l'emploie de la règle (aussi appelé numberCommentary)
      probableCommentary =
        probableInference.numberCommentary +
        ", " +
        probableInference.commentary;
      console.log(
        "(tout sauf hyp) 4.5 probableInference.activable est",
        probableInference.activable,
        "pour la règle qui est",
        ruleName,
        "et le probableCommentary est",
        probableCommentary
      );
      if (probableInference.itself === "prochaine inférence") {
        probableCommentary = "?";
      }
      if (ruleName === "~i") {
        // hyp = "hypothèse réfutée";
        hypothesisLevelNumber--;
      } else if (ruleName === "⊃i") {
        // hyp = "hypothèse validée";
        hypothesisLevelNumber--;
      }
    } else if (ruleName === "hyp") {
      console.log("4.6) est-ce que ça marche", value.futureInference);
      hypothesisLevelNumber++;
      classNames = "hypotheticalInference ";
      probableInference.itself = value.futureInference;
      probableInference.commentary = "hyp";
    }
  }

  for (let i = 0; i < hypothesisLevelNumber; i++) {
    hypothesisLevel += "|";
  }
  let nextInference = (
    <li
      className={
        "inferenceGlobal animation-fadeIn fadeIn-firstHalf probable-shadow " +
        classNames
      }
      key={value.allInferencesThemselves.length}
    >
      {setAdequacyArrows}
      <div className={"inferenceNumber infNum-color"}>
        {value.allInferencesThemselves.length + 1 + "."}
      </div>
      <div className={"hypothesis-level "}>
        {hypothesisLevel}
        {/* {this.props.hypIDSent} */}
      </div>
      <div className={"inferenceItself infIts-color"}>
        {probableInference.itself}
      </div>
      <div className={"inferenceCommentary infCom-color"}>
        {probableCommentary}
      </div>
      {/* { <div
          className={"probable-inference-checkSquare" + checkSquareClassName}
          // checksquareclickable={checkSquareClickable}
          onClick={() => {
            if (probableInference.activable) {
              value.addInference(newInference, hyp);
              value.setRuleModal(false);
            }
          }}
        >
          <i className="fas fa-check-square icon" />
        </div>} */}
    </li>
  );
  return nextInference;
}

function makeSetAdequacyArrows(value, ruleName, AIT, SN, expectedArguments) {
  let hypotheticalArrow = "",
    firstArrow = "",
    secondArrow = "";
  if (ruleName === "⊃i" || ruleName === "~i") {
    // cas des règles hypothétiques
    hypotheticalArrow = makeIndicator("hypothetical", false);
    if (value.allHypotheticalInferences[0]) {
      hypotheticalArrow = makeIndicator("hypothetical", true);
    }
    firstArrow = makeIndicator("first", false);
    if (ruleName === "~i") {
      secondArrow = makeIndicator("second", false);
    }
  }

  // cas de toutes les règles
  firstArrow = makeIndicator("first", false);
  if (SN[0] && AIT[SN[0] - 1]) {
    if (AIT[SN[0] - 1].adequacyType === "first") {
      firstArrow = makeIndicator("first", true);
    } else {
      firstArrow = makeIndicator("inadequate", true);
    }
  }
  if (expectedArguments.length === 2 && ruleName !== "⊃i" && AIT.length > 1) {
    secondArrow = makeIndicator("second", false);
    if (SN[1] && AIT[SN[1] - 1]) {
      if (AIT[SN[1] - 1].adequacyType === "second") {
        secondArrow = makeIndicator("second", true);
      } else if (ruleName === "∧i") {
        // cas spécifique de ∧i, puisque cette règle fonctionne avec toutes les inférences
        secondArrow = makeIndicator("first", true);
      } else if (ruleName === "↓i" && AIT[SN[1] - 1].adequacyType === "first") {
        // cas spécifique de ↓i
        secondArrow = makeIndicator("first", true);
      } else {
        secondArrow = makeIndicator("inadequate", true);
      }
    }
  } else if (expectedArguments.length === 3) {
    // cas spécifique de ~i, qui a 3 arguments
    if (SN[1]) {
      if (AIT[SN[1] - 1].adequacyType === "second") {
        secondArrow = makeIndicator("second", true);
      } else {
        secondArrow = makeIndicator("inadequate", true);
      }
    }
  }

  return (
    <ul className={"setAdequacyArrows "}>
      {hypotheticalArrow}
      {firstArrow}
      {secondArrow}
    </ul>
  );
}

function makeIndicator(type, bool) {
  let adequacyArrow = "▷",
    className = "";
  if (bool) {
    adequacyArrow = "▶";
  }
  if (type === "first") {
    className = "indicator-first ";
  } else if (type === "second") {
    className = "indicator-second ";
  } else if (type === "hypothetical") {
    className = "indicator-hypothetical ";
  } else if (type === "inadequate") {
    className = "indicator-inadequate ";
  } else if (type === "first-alone") {
    className = "indicator-first-alone ";
  }
  return <li className={"indicator " + className}>{adequacyArrow}</li>;
}

export default ShowProbableInference;



// WEBPACK FOOTER //
// ./src/components/Calcul Tools/Deducer Tools/ShowProbableInference.js